import React from 'react';

type Theme = 'primary' | 'secondary';

interface SubPageHeroProps {
  theme: Theme;
  title: string;
  description: React.ReactNode;
  image: string;
}

const SubPageHero: React.FC<SubPageHeroProps> = ({ theme, title, description, image }) => {
  return (
    <div className={`subpage-hero ${theme}`}>
      <div className="hero-text">
        <h1 className="hero-title">{title}</h1>
        <p className="hero-description">{description}</p>
      </div>
      <div className="hero-image">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 189 210" enable-background="new 0 0 189 210" className="hero-bg-shape"><path d="M185.959 0.5C234.03 0.500098 273 39.4134 273 87.415C273 135.417 234.03 174.33 185.959 174.33C176.838 174.33 168.046 172.928 159.784 170.33C144.22 193.926 117.452 209.5 87.041 209.5C38.9696 209.5 0 170.587 0 122.585C6.65676e-05 74.5833 38.9696 35.67 87.041 35.6699C96.161 35.6699 104.953 37.0724 113.214 39.6699C128.778 16.0735 155.547 0.5 185.959 0.5Z"/></svg>
      <img src={image} alt="Illustration" />
      </div>
    </div>
  );
};

export default SubPageHero;